import React, { useState, useEffect } from "react";
import Breadcrumbs from "../layout/breadcrumb";
import "../employees/employees.css";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import { useNavigate } from "react-router-dom";
import { AUTENTICATE_API } from "../../services/apiCalls/authApi";

function RolePermissions() {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useEffect(() => {
    // Fetch roles from the API
    const fetchRoles = async () => {
      try {
        const response = await AUTENTICATE_API.getRoles();
        if (response.status === 200) {
          const sortedRoles = response.roles.sort(
            (a, b) => new Date(b.created_dt) - new Date(a.created_dt)
          );
          setRoles(sortedRoles);
        } else {
          console.error("Failed to fetch roles:", response.message);
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    fetchRoles();
  }, []);

  const totalPages = Math.ceil(roles.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = roles.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const createRole = () => {
    navigate("/role");
  };

  const handleRowClick = (roleId) => {
    navigate(`/role?roleId=${roleId}`);
  };

  return (
    <>
      <Breadcrumbs
        title="Roles & Permissions"
        menu="Roles & Permissions"
        link="Roles List"
      />
      <div className="d-flex justify-content-end">
        <button className="btn btn-primary shadow-sm" onClick={createRole}>
          Create
        </button>
      </div>

      <div className="table-container">
        <table className="custom-table">
          <thead className="table-header">
            <tr>
              <th>Role Name</th>
              <th>Modules Assigned</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((role) => (
              <tr
                key={role.role_id}
                onClick={() => handleRowClick(role.role_id)}
              >
                <td>{role.role_name}</td>
                <td style={{ width: "70%" }}>
                  {role.modules.map((module) => module.name).join(", ")}
                </td>
                <td>{new Date(role.created_dt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div
          className="pagination"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Showing{" "}
            {Math.min((currentPage - 1) * rowsPerPage + 1, roles.length)}
            to {Math.min(currentPage * rowsPerPage, roles.length)} of{" "}
            {roles.length} entries
          </div>

          <div
            className="pagination-buttons"
            style={{
              fontSize: "14px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "5px",
            }}
          >
            {/* Left Arrow */}
            <button
              onClick={() => handleClick(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={leftArrow}
                alt="Previous"
                height="10px"
                width="10px"
                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
              />
            </button>

            {/* Page Numbers */}
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => handleClick(i + 1)}
                style={{
                  background: currentPage === i + 1 ? "#00B69B" : "transparent",
                  color: currentPage === i + 1 ? "#fff" : "#000",
                  border: "none",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {i + 1}
              </button>
            ))}

            {/* Right Arrow */}
            <button
              onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={rightArrow}
                alt="Next"
                height="10px"
                width="10px"
                style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default RolePermissions;
